"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  width: 100%;\n  height: 100%;\n  transform: scaleX(0);\n  transform-origin: 0 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: ", ";\n  background: ", ";\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  flex-direction: row;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  padding: ", ";\n  ", " {\n    padding-bottom: calc(\n      ", " + ", "\n    );\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressNotification = exports.ProgressStatus = void 0;

var feature_utils_1 = require("@thesisedu/feature-utils");

var iconoir_react_1 = require("iconoir-react");

var react_1 = __importDefault(require("react"));

var Block_1 = require("../Block");

var CircleIcon_1 = require("../CircleIcon");

var LoadingIndicators_1 = require("../LoadingIndicators");

var Typography_1 = require("../Typography");

var styledTypes_1 = require("../styledTypes");

var Notification_1 = require("./Notification");

function isValidNumber(n) {
  return n !== undefined && n !== null && !isNaN(parseFloat(n.toString()));
}

var ProgressStatus;

(function (ProgressStatus) {
  ProgressStatus[ProgressStatus["Complete"] = 0] = "Complete";
  ProgressStatus[ProgressStatus["Failed"] = 1] = "Failed";
})(ProgressStatus = exports.ProgressStatus || (exports.ProgressStatus = {}));

function ProgressNotification(_a) {
  var message = _a.message,
      current = _a.current,
      total = _a.total,
      status = _a.status,
      notificationProps = __rest(_a, ["message", "current", "total", "status"]);

  var hasProgress = isValidNumber(total) && isValidNumber(current);
  var icon = status === ProgressStatus.Complete ? react_1["default"].createElement(iconoir_react_1.Check, null) : status === ProgressStatus.Failed ? react_1["default"].createElement(iconoir_react_1.Cancel, null) : undefined;
  var isFinished = !!icon;
  return react_1["default"].createElement(Notification_1.Notification, Object.assign({}, notificationProps), react_1["default"].createElement(Container, {
    hasProgress: hasProgress,
    space: '@size-xs'
  }, react_1["default"].createElement(Typography_1.BodyLarge, null, icon ? react_1["default"].createElement(CircleIcon_1.CircleIcon, {
    color: status === ProgressStatus.Complete ? '@green' : '@red',
    children: icon
  }) : react_1["default"].createElement(LoadingIndicators_1.LoadingIndicator, null)), react_1["default"].createElement(Typography_1.Body, null, message), react_1["default"].createElement(Block_1.Space, null), hasProgress && current && total > 0 && !isFinished ? react_1["default"].createElement(Typography_1.Body, {
    color: '@text-color-secondary',
    children: feature_utils_1.Format.number(current / total, 'percentage')
  }) : null, hasProgress && !isFinished ? react_1["default"].createElement(ProgressContainer, null, react_1["default"].createElement(ProgressBar, {
    style: {
      transform: "scaleX(".concat(total > 0 ? current / total : 0, ")")
    }
  })) : null));
}

exports.ProgressNotification = ProgressNotification;
var Container = (0, styledTypes_1.styled)(Block_1.HSpaced)(_templateObject(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return (0, styledTypes_1.sif)(props.hasProgress);
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@border-radius-base'];
});
var ProgressContainer = styledTypes_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@gray-2'];
});
var ProgressBar = styledTypes_1.styled.div(_templateObject3(), function (props) {
  return props.theme['@primary-color'];
});